/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// import Pusher from 'pusher-js';
// window.Pusher = Pusher;

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? 'mt1',
//     wsHost: import.meta.env.VITE_PUSHER_HOST ?? `ws-${import.meta.env.VITE_PUSHER_APP_CLUSTER}.pusher.com`,
//     wsPort: import.meta.env.VITE_PUSHER_PORT ?? 80,
//     wssPort: import.meta.env.VITE_PUSHER_PORT ?? 443,
//     forceTLS: (import.meta.env.VITE_PUSHER_SCHEME ?? 'https') === 'https',
//     enabledTransports: ['ws', 'wss'],
// });

import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

import $ from 'jquery';
window.$ = $;
window.jQuery = $;

// import moment from "moment";
import moment from "moment/min/moment-with-locales";
window.moment = moment;

import * as Popper from "@popperjs/core"
window.Popper = Popper;

import Swal from "sweetalert2";
window.Swal = Swal;

import select2 from 'select2';
select2();

import Pikaday from "pikaday";
window.Pikaday = Pikaday;

import flatpickr from "flatpickr";
window.flatpickr = flatpickr;

import monthSelectPlugin  from "flatpickr/dist/plugins/monthSelect";
window.monthSelectPlugin = monthSelectPlugin;

import Chart from "chart.js/auto";
window.Chart = Chart;
import 'chartjs-adapter-moment';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.register(ChartDataLabels);
Chart.defaults.set('plugins.datalabels', {
  formatter: function(value, context) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }
});

import Lightbox from '@rat.md/bs-lightbox';
window.Lightbox = Lightbox;

import CopyButtonPlugin from 'highlightjs-copy';
window.CopyButtonPlugin = CopyButtonPlugin;

import hljs from 'highlight.js';
import hljsJavascript from 'highlight.js/lib/languages/javascript';
import hljsJson from 'highlight.js/lib/languages/json';
import hljsPhp from 'highlight.js/lib/languages/php';
window.hljs = hljs;
window.hljs.registerLanguage('javascript', hljsJavascript);
window.hljs.registerLanguage('json', hljsJson);
window.hljs.registerLanguage('php', hljsPhp);
